import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/**
 * Proceeds or declines a restricted-category flag. Proceeding approves the
 * screen the reviewer saw and classifies the business lines without
 * re-screening; `catalogChanged` says the catalog moved since that screen.
 */
export const resolveHsaRestrictedReview = {
  name: "resolveHsaRestrictedReview" as const,
  input: z.object({
    teamId: zExt.objectId(),
    decision: z.enum(["proceeded", "declined"]),
    note: z.string().optional(),
  }),
  output: z.object({
    outcome: z.enum(["declined", "classified", "mcc_review_pending"]),
    catalogChanged: z.boolean(),
    classification: hsaMerchantClassificationProjection,
  }),
};
